import { createContext } from 'react';
import Consent from './Consent';
import MoreInfo from './MoreInfo';
import { IntermediaryVariant } from 'src/interviews/components/TxocInterview/machine/types';
import type { QuestionProps } from 'src/interviews/components/Question/types';

type IntermediaryViewSelectorProps = Partial<QuestionProps> & {
  isEmbedded?: boolean;
  variant: IntermediaryVariant;
};

export const IntermediaryViewContext = createContext<Partial<QuestionProps>>({});

const IntermediaryViewSelector = (props: IntermediaryViewSelectorProps) => {
  const { isEmbedded, variant, ...rest } = props;
  let context = { ...rest };
  switch (variant) {
    case IntermediaryVariant.MoreInfo:
      context = {
        ...context,
        shouldShowBackButton: true,
        shouldShowSubmitButton: true,
      };
      return (
        <IntermediaryViewContext.Provider value={context}>
          <MoreInfo isEmbedded={isEmbedded} />
        </IntermediaryViewContext.Provider>
      );
    case IntermediaryVariant.Consent:
      context = {
        ...context,
        shouldShowBackButton: true,
      };
      return (
        <IntermediaryViewContext.Provider value={context}>
          <Consent />
        </IntermediaryViewContext.Provider>
      );
    default:
      return null;
  }
};

export default IntermediaryViewSelector;
